<template>
    <div>
        <button @click="openModal" class="support-button" :title="$tc('layout.header.support')">
            <i class="icon icon-help"></i>
        </button>

        <SupportModal v-if="showModal" :formData="formData" @close="closeModal" @update:formData="updateFormData" />
    </div>
</template>

<script lang="ts">
import Vue from "@/store/strong-vue";
import SupportModal from "./SupportModal.vue";

interface FormData {
    email: string;
    message: string;
}

export default Vue.extend({
    name: "SupportButton",
    components: {
        SupportModal,
    },
    data() {
        return {
            showModal: false,
            formData: {
                email: "",
                message: "",
            } as FormData,
        };
    },
    methods: {
        openModal() {
            const user = this.$state.user.user;
            if (user && !this.formData.email) {
                this.formData.email = user.email || "";
            }
            this.showModal = true;
        },
        closeModal() {
            this.showModal = false;
        },
        updateFormData(data: FormData) {
            this.formData = data;
        },
    },
});
</script>

<style scoped lang="scss">
@use "src/scss/variables";

.support-button {
    position: fixed;
    bottom: 24px;
    right: 24px;
    width: 48px;
    height: 48px;
    border-radius: 50%;
    background-color: var(--color-primary);
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    cursor: pointer;
    transition: all 0.3s ease;
    z-index: variables.$z-index-support-btn;

    &:hover {
        background-color: var(--color-primary);
        box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
        transform: scale(1.05);
        filter: brightness(0.9);
    }

    &:active {
        transform: scale(1);
    }

    .icon {
        font-size: 24px;
        color: #fefefe;
    }

    @media (max-width: 768px) {
        width: 48px;
        height: 48px;
        bottom: 20px;
        right: 20px;

        .icon {
            font-size: 20px;
        }
    }
}
</style>
